// @ts-nocheck
import constants from '@/constants';

const { ACTIONS } = constants.ROOT_COMPS.GFPP;

export default {
  enabledActions: [ACTIONS.SETTINGS],
  mobileEnabledActions: [],
  presetActions: {},
};
